import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { environment } from '@environments/environment';
import { ClientSessionService } from 'src/core/services/client-session/client-session.service';
import { TenantContextService } from 'src/core/services/tenant-context/tenant-context.service';

const AUTH_PATHS = [
  `${environment.workflowApiUrl}/portal/client/login`,
  `${environment.workflowApiUrl}/portal/client/session`,
];

const SESSION_ERROR_CODES = ['portal_client_session_required', 'portal_client_session_expired'];

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const session = inject(ClientSessionService);
  const tenant = inject(TenantContextService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const isAuthRequest = AUTH_PATHS.some((path) => req.url.startsWith(path));
      const code = String(error.error?.code ?? '');
      const isSessionError = error.status === 401 && (SESSION_ERROR_CODES.includes(code) || !code);

      if (isSessionError && !isAuthRequest) {
        session.clearSession();
        tenant.goToLogin();
      }
      return throwError(() => error);
    })
  );
};
